import React from 'react';

const CustomerOptionComponent = ({ data, innerProps, isFocused, isSelected }) => {
    const customer = data.customer;
    
    return (
        <div
            {...innerProps}
            data-test={`customer-async-option`}
            style={{
                display: 'flex',
                alignItems: 'center',
                padding: '8px 12px',
                backgroundColor: isSelected ? '#007bff' : isFocused ? '#f8f9fa' : 'white',
                color: isSelected ? 'white' : 'black',
                cursor: 'pointer',
                borderBottom: '1px solid #eee'
            }}
        >
            <div style={{ 
                display: 'flex', 
                width: '100%',
                fontSize: '14px'
            }}>
                <div style={{ 
                    width: '50px',
                    fontWeight: 'bold',
                    marginRight: '10px'
                }}>
                    {customer.code}
                </div>
                <div style={{ 
                    flex: 1,
                    textAlign: 'left'
                }}>
                    {customer.name}
                </div>
            </div>
        </div>
    );
};

export default CustomerOptionComponent; 